import React, {
  useState,
  useEffect,
  createElement,
  Fragment,
  useRef,
} from "react";
import {
  Divider,
  Box,
  Typography,
  makeStyles,
  Container,
  Paper,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  useMediaQuery,
} from "@material-ui/core";
import { useParams } from "react-router-dom";
import { useLazyQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { useForm, Controller, useWatch } from "react-hook-form";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { ReactComponent as LineIcon } from "../images/socialIcons/LineIcon.svg";
import { LineShareButton } from "react-share";
import InnerHTML from "dangerously-set-html-content";

import Grid from "../components/Grid";
import { Card, CardContent } from "../components/Card";
import moment from "moment";
import Button from "../components/Button";
import Table from "../components/Table";
import CombinedTable from "../components/CombinedTable";
import { useAlert } from "../components/Alert";
import AuctionRecord from "./components/AuctionRecord";
import BulletinLink from "./components/BulletinLink";
import Map from "./components/Map";

const GET_FORECLOSURE = gql`
  query foreclosure($obj_no: Int!) {
    foreclosure(obj_no: $obj_no) {
      obj_no
      obj_type
      obj_court
      obj_city
      obj_area
      obj_section
      obj_section_s
      obj_landno
      obj_address
      obj_date_ymd
      obj_date_hi
      obj_time
      obj_total_floor
      obj_land_floor
      obj_build_floor
      obj_s_floor
      obj_add_floor
      obj_c_floor
      obj_margin
      obj_price
      obj_land_data
      obj_build_data
      obj_bulletin_data
      obj_another
      obj_caseno
      obj_debtor
      obj_share
      obj_str
      obj_link
      obj_creditor
      images {
        id
        imageUrl
      }
    }
  }
`;

export default function SaleObjDetail() {
  const isTable = useMediaQuery("(min-width:768px)");
  const Alert = useAlert();
  const { id } = useParams();
  const [images, setImages] = useState([]);
  const [newData, setNewData] = useState([]);
  const [mapData, setMapData] = useState({});
  const [print, setPrint] = useState(false);
  const { control } = useForm({
    defaultValues: {
      casenoHide: false,
    },
  });
  const casenoHide = useWatch({ control, name: "casenoHide" });
  const useStyles = makeStyles((theme) => ({
    DocumentContainerCenter: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      minWidth: "100px",
    },
    socialBtns: {
      display: "flex",
      alingItems: "center",
    },
    svgIcons: {
      width: "50px",
      height: "50px",
    },
    directionRow: {
      display: casenoHide ? "none" : "flex",
      // display: "flex",
    },
  }));
  const classes = useStyles();
  const [getForeclosures, { data, loading }] = useLazyQuery(GET_FORECLOSURE, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onCompleted({ foreclosure }) {
      if (foreclosure) {
        let newData = [];
        newData.push({
          obj_type: foreclosure.obj_type,
          obj_date_ymd: foreclosure.obj_date_ymd,
          obj_date_hi: foreclosure.obj_date_hi,
          obj_time: foreclosure.obj_time,
          obj_total_floor: foreclosure.obj_total_floor,
          obj_land_floor: foreclosure.obj_land_floor,
          obj_build_floor: foreclosure.obj_build_floor,
          obj_s_floor: foreclosure.obj_s_floor,
          obj_add_floor: foreclosure.obj_add_floor,
          obj_c_floor: foreclosure.obj_c_floor,
          obj_margin: foreclosure.obj_margin,
          obj_price: foreclosure.obj_price,
        });
        setNewData(newData);
        setImages(foreclosure.images);
        setMapData({
          obj_type: foreclosure.obj_type,
          obj_city: foreclosure.obj_city,
          obj_area: foreclosure.obj_area,
          obj_address: foreclosure.obj_address,
          obj_section: foreclosure.obj_section,
          obj_section_s: foreclosure.obj_section_s,
          obj_landno: foreclosure.obj_landno,
        });
      }
    },
    onError(error) {
      Alert.alert("通知", `${error}`, [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    },
  });
  function print_action() {
    // TODO
    var restorepage = document.body.innerHTML;
    var printcontent = document.getElementById("printable").innerHTML;
    document.body.innerHTML = printcontent;
    window.print();
    document.body.innerHTML = restorepage;
    window.location.reload();
    setPrint(false);
  }

  function getCaseName(obj_str, obj_share, obj_caseno, obj_another) {
    const share = Array.from(obj_share);
    const condition = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    let sourcefnp = false;
    if (share.indexOf("台") > -1 && share.indexOf("金") > -1) {
      sourcefnp = true;
    } else {
      share.forEach((item) => {
        condition.map((item2) => {
          if (item.indexOf(item2) > -1) sourcefnp = true;
        });
      });
    }

    return sourcefnp
      ? obj_str +
          "批號" +
          obj_caseno +
          (!!obj_another &&
          obj_another.indexOf("(") === -1 &&
          obj_another.indexOf("-") === -1
            ? "(" + obj_another + ")"
            : obj_another)
      : obj_str +
          obj_share +
          obj_caseno +
          (!!obj_another &&
          obj_another.indexOf("(") === -1 &&
          obj_another.indexOf("-") === -1
            ? "(" + obj_another + ")"
            : obj_another);
  }
  useEffect(() => {
    if (id) {
      getForeclosures({
        variables: {
          obj_no: Number(id),
        },
      });
    }
  }, [id]);
  if (loading) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return data ? (
      <Box id="printable">
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item>
                <Controller
                  name="casenoHide"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <IconButton
                      onClick={() => {
                        field.onChange(!casenoHide);
                      }}
                    >
                      {casenoHide ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                  )}
                />
              </Grid>
              <Grid item classes={{ root: classes.directionRow }}>
                <Typography style={{ color: "#ff1744", fontSize: 20 }}>
                  {"案號:" +
                    getCaseName(
                      data.foreclosure.obj_str,
                      data.foreclosure.obj_share,
                      data.foreclosure.obj_caseno,
                      data.foreclosure.obj_another
                    )}
                </Typography>
              </Grid>
              <Grid item>
                <Typography color="primary" style={{ fontSize: 20 }}>
                  {`債務人:${
                    data.foreclosure.obj_debtor
                      ? data.foreclosure.obj_debtor.substr(0, 1) + "**"
                      : ""
                  }`}
                </Typography>
              </Grid>

              {!print && (
                <>
                  <BulletinLink
                    data={{
                      obj_str: data.foreclosure.obj_str,
                      obj_share: data.foreclosure.obj_share,
                      obj_another: data.foreclosure.obj_another,
                      obj_caseno: data.foreclosure.obj_caseno,
                    }}
                  />
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onPress={async () => {
                        await setPrint(true);
                        print_action();
                      }}
                    >
                      列印
                    </Button>
                  </Grid>
                  <Grid item>
                    <LineShareButton
                      url={
                        window.location.origin +
                        "/" +
                        "simple-info" +
                        "/" +
                        id +
                        "?mobile=" +
                        localStorage.getItem("@fullhouseUserMobile")
                      }
                    >
                      <Box className={classes.socialBtns}>
                        {createElement(LineIcon, {
                          className: classes.svgIcons,
                        })}
                      </Box>
                    </LineShareButton>
                  </Grid>
                  <Grid container item spacing={1}>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onPress={() => {
                          window.open(
                            `https://ngis.tcd.gov.tw/TCDPageD2.aspx`,
                            "_blank",
                            "noopener"
                          );
                        }}
                      >
                        國土規劃入口網
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onPress={() => {
                          window.open(
                            `http://maps.google.com.tw/?q=${
                              data.foreclosure.obj_type === "H"
                                ? data.foreclosure.obj_city +
                                  data.foreclosure.obj_area +
                                  data.foreclosure.obj_address
                                : data.foreclosure.obj_city +
                                  data.foreclosure.obj_area +
                                  data.foreclosure.obj_section +
                                  "段" +
                                  data.foreclosure.obj_section_s +
                                  (data.foreclosure.obj_section_s
                                    ? "小段"
                                    : "") +
                                  data.foreclosure.obj_landno +
                                  (data.foreclosure.obj_landno ? "地號" : "")
                            }&t=h`,
                            "_blank",
                            "noopener"
                          );
                        }}
                      >
                        衛星圖
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onPress={() => {
                          window.open(
                            `http://maps.google.com.tw/?q=${
                              data.foreclosure.obj_type === "H"
                                ? data.foreclosure.obj_city +
                                  data.foreclosure.obj_area +
                                  data.foreclosure.obj_address
                                : data.foreclosure.obj_city +
                                  data.foreclosure.obj_area +
                                  data.foreclosure.obj_section +
                                  "段" +
                                  data.foreclosure.obj_section_s +
                                  (data.foreclosure.obj_section_s
                                    ? "小段"
                                    : "") +
                                  data.foreclosure.obj_landno +
                                  (data.foreclosure.obj_landno ? "地號" : "")
                            }`,
                            "_blank",
                            "noopener"
                          );
                        }}
                      >
                        地圖
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onPress={() => {
                          window.open(
                            `https://easymap.land.moi.gov.tw/Index`,
                            "_blank",
                            "noopener"
                          );
                        }}
                      >
                        地籍圖系統
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onPress={() => {
                          window.open(
                            `https://maps.nlsc.gov.tw/T09/mapshow.action`,
                            "_blank",
                            "noopener"
                          );
                        }}
                      >
                        國土測繪中心
                      </Button>
                    </Grid>
                  </Grid>
                </>
              )}
            </Grid>
            <Grid container item spacing={1}>
              <Typography variant="h5">
                {data.foreclosure.obj_type === "H"
                  ? data.foreclosure.obj_city +
                    data.foreclosure.obj_area +
                    data.foreclosure.obj_address
                  : data.foreclosure.obj_city +
                    data.foreclosure.obj_area +
                    data.foreclosure.obj_section +
                    "段" +
                    data.foreclosure.obj_section_s +
                    (data.foreclosure.obj_section_s ? "小段" : "") +
                    data.foreclosure.obj_landno +
                    (data.foreclosure.obj_landno ? "地號" : "")}
              </Typography>
            </Grid>
          </CardContent>
          <Divider />
          {/* TODO */}
          <CardContent>
            {isTable ? (
              <>
                <CombinedTable
                  data={newData ? newData : []}
                  tableContainerProps={{ component: Paper }}
                  tableProps={{ style: { minWidth: 650 } }}
                  head={{
                    children: [
                      { children: "投標日" },
                      { children: "拍次" },
                      { children: "總建坪" },
                      { children: "地坪" },
                      { children: "主建坪" },
                      { children: "附建坪" },
                      { children: "增建坪" },
                      { children: "公設坪" },
                      { children: "公告現值" },
                      { children: "保證金" },
                      { children: "底價" },
                    ],
                  }}
                  body={(item) => {
                    return {
                      children: [
                        {
                          children:
                            moment(item.obj_date_ymd).format("YYYY/MM/DD") +
                            "\n" +
                            moment(item.obj_date_hi).format("HH:mm"),
                        },
                        { children: item.obj_time },
                        { children: item.obj_total_floor },
                        { children: item.obj_land_floor },
                        { children: item.obj_build_floor },
                        { children: item.obj_s_floor },
                        { children: item.obj_add_floor },
                        { children: item.obj_c_floor },
                        { children: "公告現值" },
                        {
                          children: (item.obj_margin / 10000).toFixed(2) + "萬",
                        },
                        { children: item.obj_price + "萬" },
                      ],
                    };
                  }}
                />
              </>
            ) : (
              <Grid container spacing={1} direction="row">
                <Grid container xs={8}>
                  <Typography color="primary">投標日:</Typography>
                  <Typography>
                    {moment(data.foreclosure.obj_date_ymd).format(
                      "YYYY/MM/DD"
                    ) +
                      "\u2002" +
                      moment(data.foreclosure.obj_date_hi).format("HH:mm")}
                  </Typography>
                </Grid>
                <Grid container xs={4}>
                  <Typography color="primary">拍次:</Typography>
                  <Typography>{data.foreclosure.obj_time}</Typography>
                </Grid>
                <Grid container xs={4}>
                  <Typography color="primary">總建坪:</Typography>
                  <Typography>
                    {data.foreclosure.obj_type === "L"
                      ? 0
                      : data.foreclosure.obj_total_floor}
                  </Typography>
                </Grid>
                <Grid container xs={4}>
                  <Typography color="primary">地坪:</Typography>
                  <Typography>{data.foreclosure.obj_land_floor}</Typography>
                </Grid>
                <Grid container xs={4}>
                  <Typography color="primary">主建坪:</Typography>
                  <Typography>{data.foreclosure.obj_build_floor}</Typography>
                </Grid>
                <Grid container xs={4}>
                  <Typography color="primary">附建坪:</Typography>
                  <Typography>{data.foreclosure.obj_s_floor}</Typography>
                </Grid>
                <Grid container xs={4}>
                  <Typography color="primary">增建坪:</Typography>
                  <Typography>{data.foreclosure.obj_add_floor}</Typography>
                </Grid>
                <Grid container xs={4}>
                  <Typography color="primary">公設坪:</Typography>
                  <Typography>{data.foreclosure.obj_c_floor}</Typography>
                </Grid>
                <Grid container xs={8}>
                  <Typography color="primary">公告現值:</Typography>
                  <Typography>公告現值</Typography>
                </Grid>
                <Grid container xs={6}>
                  <Typography color="primary">保證金:</Typography>
                  <Typography>
                    {(data.foreclosure.obj_margin / 10000).toFixed(2) + "萬"}
                  </Typography>
                </Grid>
                <Grid container xs={6}>
                  <Typography color="primary">底價:</Typography>
                  <Typography>{data.foreclosure.obj_price + "萬"}</Typography>
                </Grid>
              </Grid>
            )}
          </CardContent>
          <Divider />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item classes={{ root: classes.DocumentContainerCenter }}>
                <Typography>土地</Typography>
                <Typography style={{ color: "#3d5afe" }}>
                  {data.foreclosure.obj_total_floor === 0
                    ? "建坪:" + 0
                    : "建坪:" +
                      (
                        data.foreclosure.obj_price /
                        data.foreclosure.obj_total_floor
                      ).toFixed(2) +
                      "萬" +
                      "\n"}
                </Typography>
                <Typography style={{ color: "#3d5afe" }}>
                  {data.foreclosure.obj_land_floor === 0
                    ? "地坪:" + 0
                    : "地坪:" +
                      (
                        data.foreclosure.obj_price /
                        data.foreclosure.obj_land_floor
                      ).toFixed(2) +
                      "萬"}
                </Typography>
                {"\u2002"}
              </Grid>
              <Grid item>
                <Divider
                  orientation="vertical"
                  flexItem
                  style={{ height: "100%" }}
                />
              </Grid>
              <Grid item style={{ flex: 1 }}>
                <Typography style={{ whiteSpace: "break-spaces" }}>
                  {data.foreclosure.obj_land_data.replace(/<br>/g, "\n")}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item classes={{ root: classes.DocumentContainerCenter }}>
                <Typography>建物</Typography>
                <Typography style={{ color: "#3d5afe" }}>{`公設比:${
                  Boolean(data.foreclosure.obj_c_floor) &&
                  Boolean(data.foreclosure.obj_total_floor)
                    ? (
                        (data.foreclosure.obj_c_floor /
                          data.foreclosure.obj_total_floor) *
                        100
                      ).toFixed()
                    : 0
                }%`}</Typography>
                {"\u2002"}
              </Grid>
              <Grid item>
                <Divider
                  orientation="vertical"
                  flexItem
                  style={{ height: "100%" }}
                />
              </Grid>
              <Grid item style={{ flex: 1 }}>
                <Typography style={{ whiteSpace: "break-spaces" }}>
                  {data.foreclosure.obj_build_data.replace(/<br>/g, "\n")}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item classes={{ root: classes.DocumentContainerCenter }}>
                <Typography>公告筆錄</Typography>
                {"\u2002"}
              </Grid>
              <Grid item>
                <Divider
                  orientation="vertical"
                  flexItem
                  style={{ height: "100%" }}
                />
              </Grid>
              <Accordion elevation={0} style={{ width: "90%" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                ></AccordionSummary>
                <AccordionDetails>
                  <Grid item style={{ flex: 1 }}>
                    <Typography style={{ whiteSpace: "break-spaces" }}>
                      {data.foreclosure.obj_bulletin_data.replace(
                        /<br>/g,
                        "\n"
                      )}
                    </Typography>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </CardContent>
          <Divider />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item classes={{ root: classes.DocumentContainerCenter }}>
                <Typography>拍賣紀錄</Typography>
                {"\u2002"}
              </Grid>
              <Grid item>
                <Divider
                  orientation="vertical"
                  flexItem
                  style={{ height: "100%" }}
                />
              </Grid>
              <Grid item style={{ flex: 1 }}>
                <AuctionRecord
                  data={{
                    obj_str: data.foreclosure.obj_str,
                    obj_share: data.foreclosure.obj_share,
                    obj_caseno: data.foreclosure.obj_caseno,
                    obj_another: data.foreclosure.obj_another,
                    obj_creditor: data.foreclosure.obj_creditor,
                  }}
                />
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item classes={{ root: classes.DocumentContainerCenter }}>
                <Typography>土地增值</Typography>
                {"\u2002"}
              </Grid>
              <Grid item>
                <Divider
                  orientation="vertical"
                  flexItem
                  style={{ height: "100%" }}
                />
              </Grid>
              <Accordion elevation={0} style={{ width: "90%" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                ></AccordionSummary>
                <AccordionDetails>
                  <Grid item style={{ flex: 1 }}>
                    <Typography
                      style={{ whiteSpace: "break-spaces" }}
                    ></Typography>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </CardContent>
          <Divider />
          {images.length > 0 && (
            <Grid container spacing={1} justifyContent="space-around">
              {images.map((item, index) => {
                if (index <= 3) {
                  return (
                    <Grid item>
                      <img
                        src={item.imageUrl}
                        key={index}
                        style={{
                          // 如果要完整顯示改成contain
                          objectFit: "cover",
                          width: "100%",
                          // height: isPhone ? "300px" : isTablet ? "550px" : "600px",
                          maxHeight: "200px",
                          borderRadius: "10px",
                          padding: "5px",
                        }}
                      />
                    </Grid>
                  );
                }
              })}
            </Grid>
          )}
          <CardContent>
            <Map mapData={mapData} height={"400px"} direction={"row"} sm={6} />
            {/* {print ? (
              <InnerHTML
                html={`<html>
      <body style="margin: 0; padding: 0">
      <iframe 
      width="600" 
      height="450" 
      frameborder="0" 
      style="border:0" 
      src="https://www.google.com/maps/embed/v1/place?key=AIzaSyAmN8gx3xtVVI4kMAvjAruO9yUgPenMPqE&q=高雄市政府" 
      allowfullscreen>
  </iframe>
      </body>
    </html>`}
              />
            ) : (
              <Map mapData={mapData} size={"400px"} direction={"row"} sm={6} />
            )} */}
          </CardContent>
        </Card>
      </Box>
    ) : (
      <Card></Card>
    );
  }
}
